import type { RendererContext, RenderParams, StyleRenderer } from '../../types';

export type { RendererContext, RenderParams, StyleRenderer };

/**
 * Factory: create a preview RendererContext
 */
export function createPreviewContext(scaleFactor = 1): RendererContext {
  return {
    mode: 'preview',
    dpi: 96,
    scaleFactor,
  };
}

/**
 * Factory: create a PDF/print RendererContext
 */
export function createPrintContext(): RendererContext {
  return {
    mode: 'pdf',
    dpi: 350,
    scaleFactor: 350 / 96,
  };
}

/**
 * Default render params fallback
 */
export function defaultRenderParams(overrides?: Partial<RenderParams>): RenderParams {
  return {
    text: 'うちわ',
    textColor: '#FF6B9D',
    backgroundColor: '#FFFFFF',
    secondaryColor: '#FFB5D1',
    fontSize: 120,
    textOrientation: 'vertical',
    canvasWidth: 400,
    canvasHeight: 400,
    effects: [],
    ...overrides,
  };
}

/**
 * Registry for all style renderers
 */
const rendererRegistry = new Map<string, StyleRenderer>();

export function registerRenderer(renderer: StyleRenderer): void {
  rendererRegistry.set(renderer.name, renderer);
}

export function getRenderer(name: string): StyleRenderer | undefined {
  return rendererRegistry.get(name);
}

export function getAllRenderers(): StyleRenderer[] {
  return Array.from(rendererRegistry.values());
}
